import { PracticeTypeData } from "@/utils/practiceTypeData";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

interface PracticeTypeFAQProps {
  practiceType: PracticeTypeData;
}

const PracticeTypeFAQ = ({ practiceType }: PracticeTypeFAQProps) => {
  return (
    <section className="py-12 sm:py-16 md:py-20 bg-muted/30">
      <div className="container mx-auto max-w-4xl px-4">
        <div className="text-center mb-12">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold mb-4">
            Häufige Fragen zu Cyberversicherungen für {practiceType.name}
          </h2>
        </div>

        <Accordion type="single" collapsible className="space-y-4">
          {practiceType.faqs.map((faq, index) => (
            <AccordionItem
              key={index}
              value={`item-${index}`}
              className="bg-card border border-border rounded-lg px-6"
            >
              <AccordionTrigger className="text-left hover:no-underline">
                <span className="text-base font-semibold">{faq.question}</span>
              </AccordionTrigger>
              <AccordionContent className="text-muted-foreground">
                {faq.answer}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
};

export default PracticeTypeFAQ;
